var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"w-100 object-fit-contain",attrs:{"src":_vm.image}})
}
var staticRenderFns = []

export { render, staticRenderFns }